export default {
    'zh_CN': {
        'common.sys-dict-data.id.label': '字典编码',
        'common.sys-dict-data.id.holder': '请输入字典编码',
        
        
        'common.sys-dict-data.id.required': '字典编码必填',
        'common.sys-dict-data.dictSign.label': '字典类型',
        'common.sys-dict-data.dictSign.holder': '请输入字典类型',
        'common.sys-dict-data.dictSign.max': '字典类型最多100个字符',
        
        'common.sys-dict-data.dictSign.required': '字典类型必填',
        'common.sys-dict-data.dictValue.label': '字典标签',
        'common.sys-dict-data.dictValue.holder': '请输入字典标签',
        'common.sys-dict-data.dictValue.max': '字典标签最多100个字符',
        
        'common.sys-dict-data.dictValue.required': '字典标签必填',
        'common.sys-dict-data.dictKey.label': '字典键值',
        'common.sys-dict-data.dictKey.holder': '请输入字典键值',
        'common.sys-dict-data.dictKey.max': '字典键值最多100个字符',
        
        'common.sys-dict-data.dictKey.required': '字典键值必填',
        'common.sys-dict-data.styleClass.label': '表格回显样式',
        'common.sys-dict-data.styleClass.holder': '请输入表格回显样式',
        'common.sys-dict-data.styleClass.max': '表格回显样式最多100个字符',
        
        'common.sys-dict-data.styleClass.required': '表格回显样式必填',
        'common.sys-dict-data.isDefault.label': '是否默认',
        'common.sys-dict-data.isDefault.holder': '请输入是否默认',
        
        
        'common.sys-dict-data.isDefault.dictionary': ()=>[{value:0,label:'否'},{value:1,label:'是'}],
        'common.sys-dict-data.isDefault.required': '是否默认必填',
        'common.sys-dict-data.dictSort.label': '字典排序',
        'common.sys-dict-data.dictSort.holder': '请输入字典排序',
        
        
        'common.sys-dict-data.dictSort.required': '字典排序必填',
        'common.sys-dict-data.status.label': '状态',
        'common.sys-dict-data.status.holder': '请输入状态',
        
        
        'common.sys-dict-data.status.dictionary': ()=>[{value:0,label:'禁用'},{value:1,label:'启用'}],
        'common.sys-dict-data.status.required': '状态必填',
        'common.sys-dict-data.remark.label': '备注',
        'common.sys-dict-data.remark.holder': '请输入备注',
        'common.sys-dict-data.remark.max': '备注最多500个字符',
        
        'common.sys-dict-data.remark.required': '备注必填',
        'common.sys-dict-data.createTime.label': '创建时间',
        'common.sys-dict-data.createTime.holder': '请输入创建时间',
        'common.sys-dict-data.createTime.required': '创建时间必填',
        'common.sys-dict-data.updateTime.label': '更新时间',
        'common.sys-dict-data.updateTime.holder': '请输入更新时间',
        'common.sys-dict-data.updateTime.required': '更新时间必填',
        'common.sys-dict-data.deleted.label': '是否删除',
        'common.sys-dict-data.deleted.holder': '请输入是否删除',
        'common.sys-dict-data.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'common.sys-dict-data.id.label': '字典编码',
        'common.sys-dict-data.id.holder': '請輸入字典编码',
        
        
        'common.sys-dict-data.id.required': '字典编码必填',
        'common.sys-dict-data.dictSign.label': '字典类型',
        'common.sys-dict-data.dictSign.holder': '請輸入字典类型',
        
        
        'common.sys-dict-data.dictSign.required': '字典类型必填',
        'common.sys-dict-data.dictValue.label': '字典标签',
        'common.sys-dict-data.dictValue.holder': '請輸入字典标签',
        
        
        'common.sys-dict-data.dictValue.required': '字典标签必填',
        'common.sys-dict-data.dictKey.label': '字典键值',
        'common.sys-dict-data.dictKey.holder': '請輸入字典键值',
        
        
        'common.sys-dict-data.dictKey.required': '字典键值必填',
        'common.sys-dict-data.styleClass.label': '表格回显样式',
        'common.sys-dict-data.styleClass.holder': '請輸入表格回显样式',
        
        
        'common.sys-dict-data.styleClass.required': '表格回显样式必填',
        'common.sys-dict-data.isDefault.label': '是否默认',
        'common.sys-dict-data.isDefault.holder': '請輸入是否默认',
        
        
        'common.sys-dict-data.isDefault.required': '是否默认必填',
        'common.sys-dict-data.dictSort.label': '字典排序',
        'common.sys-dict-data.dictSort.holder': '請輸入字典排序',
        
        
        'common.sys-dict-data.dictSort.required': '字典排序必填',
        'common.sys-dict-data.status.label': '状态',
        'common.sys-dict-data.status.holder': '請輸入状态',
        
        
        'common.sys-dict-data.status.required': '状态必填',
        'common.sys-dict-data.remark.label': '备注',
        'common.sys-dict-data.remark.holder': '請輸入备注',
        
        
        'common.sys-dict-data.remark.required': '备注必填',
        'common.sys-dict-data.createTime.label': '创建时间',
        'common.sys-dict-data.createTime.holder': '請輸入创建时间',
        
        
        'common.sys-dict-data.createTime.required': '创建时间必填',
        'common.sys-dict-data.updateTime.label': '更新时间',
        'common.sys-dict-data.updateTime.holder': '請輸入更新时间',
        
        
        'common.sys-dict-data.updateTime.required': '更新时间必填',
        'common.sys-dict-data.deleted.label': '是否删除',
        'common.sys-dict-data.deleted.holder': '請輸入是否删除',
        
        
        'common.sys-dict-data.deleted.required': '是否删除必填'
    },
    'en_US': {
        'common.sys-dict-data.id.label': 'id',
        'common.sys-dict-data.id.holder': 'Enter id',
        'common.sys-dict-data.id.max': 'id max length: 字典编码',
        
        
        'common.sys-dict-data.id.required': 'id required',
        'common.sys-dict-data.dictSign.label': 'dictSign',
        'common.sys-dict-data.dictSign.holder': 'Enter dictSign',
        'common.sys-dict-data.dictSign.max': 'dictSign max length: 字典类型',
        
        
        'common.sys-dict-data.dictSign.required': 'dictSign required',
        'common.sys-dict-data.dictValue.label': 'dictValue',
        'common.sys-dict-data.dictValue.holder': 'Enter dictValue',
        'common.sys-dict-data.dictValue.max': 'dictValue max length: 字典标签',
        
        
        'common.sys-dict-data.dictValue.required': 'dictValue required',
        'common.sys-dict-data.dictKey.label': 'dictKey',
        'common.sys-dict-data.dictKey.holder': 'Enter dictKey',
        'common.sys-dict-data.dictKey.max': 'dictKey max length: 字典键值',
        
        
        'common.sys-dict-data.dictKey.required': 'dictKey required',
        'common.sys-dict-data.styleClass.label': 'styleClass',
        'common.sys-dict-data.styleClass.holder': 'Enter styleClass',
        'common.sys-dict-data.styleClass.max': 'styleClass max length: 表格回显样式',
        
        
        'common.sys-dict-data.styleClass.required': 'styleClass required',
        'common.sys-dict-data.isDefault.label': 'isDefault',
        'common.sys-dict-data.isDefault.holder': 'Enter isDefault',
        'common.sys-dict-data.isDefault.max': 'isDefault max length: 是否默认',
        
        
        'common.sys-dict-data.isDefault.required': 'isDefault required',
        'common.sys-dict-data.dictSort.label': 'dictSort',
        'common.sys-dict-data.dictSort.holder': 'Enter dictSort',
        'common.sys-dict-data.dictSort.max': 'dictSort max length: 字典排序',
        
        
        'common.sys-dict-data.dictSort.required': 'dictSort required',
        'common.sys-dict-data.status.label': 'status',
        'common.sys-dict-data.status.holder': 'Enter status',
        'common.sys-dict-data.status.max': 'status max length: 状态',
        
        
        'common.sys-dict-data.status.required': 'status required',
        'common.sys-dict-data.remark.label': 'remark',
        'common.sys-dict-data.remark.holder': 'Enter remark',
        'common.sys-dict-data.remark.max': 'remark max length: 备注',
        
        
        'common.sys-dict-data.remark.required': 'remark required',
        'common.sys-dict-data.createTime.label': 'createTime',
        'common.sys-dict-data.createTime.holder': 'Enter createTime',
        'common.sys-dict-data.createTime.max': 'createTime max length: 创建时间',
        
        
        'common.sys-dict-data.createTime.required': 'createTime required',
        'common.sys-dict-data.updateTime.label': 'updateTime',
        'common.sys-dict-data.updateTime.holder': 'Enter updateTime',
        'common.sys-dict-data.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'common.sys-dict-data.updateTime.required': 'updateTime required',
        'common.sys-dict-data.deleted.label': 'deleted',
        'common.sys-dict-data.deleted.holder': 'Enter deleted',
        'common.sys-dict-data.deleted.max': 'deleted max length: 是否删除',
        
        
        'common.sys-dict-data.deleted.required': 'deleted required'
    }
}
